import React from 'react';
// styles and images
import styles from './Graphics.module.css';

/*****************************************
 * * Create SVG Content
 *****************************************/
export function createContent0() {
  let pathRefs = [];
  let content = [];

  // content.push(
  //   <rect key='background' className={styles.st0} width='800' height='400' />
  // );

  content.push(
    <path
      key='circle'
      className={`${styles.circle} ${styles.shape}`}
      d='M300,200a100,100 0 1,0 200,0a100,100 0 1,0 -200,0'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='circle-shape'
      className={`${styles.shape}`}
      d='M300,200a100,100 0 1,0 200,0a100,100 0 1,0 -200,0'
    />
  );

  content.push(
    <path
      key='square'
      className={`${styles.square} ${styles.shape}`}
      d='M525.667,321.333H274.333V78.667h251.333V321.333z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='star'
      className={`${styles.star} ${styles.shape}`}
      d='M400,82.531l38.168,77.336l85.346,12.401l-61.757,60.198l14.579,85.001L400,277.336l-76.336,40.132
      l14.579-85.001l-61.757-60.198l85.346-12.401L400,82.531z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  return {
    content,
    pathRefs,
  };
}

/*****************************************
 * * Create Animation
 *****************************************/
export function createAnim0(anim, pathRefs, speed) {
  anim.clear();
  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[1],
          type: 'linear',
          map: 'size',
        },
        // ease: 'power1.inOut',
      },
      '+=0.5'
    )
  );

  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[2],
          type: 'linear',
          map: 'size',
        },
        // ease: 'power1.inOut',
      },
      '+=0.5'
    )
  );

  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[0],
          type: 'linear',
          map: 'size',
        },
        // ease: 'power1.inOut',
      },
      '+=.5'
    )
  );
}
